import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid';
import classNames from 'classnames';

export class ColorPicker extends Component {
  static propTypes = {
    color: PropTypes.string.isRequired,
    onItemClick: PropTypes.func.isRequired,
    componentCSS: PropTypes.string,
    backgroundComponentCSS: PropTypes.string
  }

  constructor(props) {
    super(props);

    this.state = {
      componentCSS: this.props.componentCSS || 'color-picker',
      backgroundComponentCSS: this.props.backgroundComponentCSS || 'color-picker-bg',
      selectedColor: this.props.color
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextState.color !== this.state.selectedColor;
  }

  onItemClick = color => {
    this.setState({selectedColor: color}, () => this.props.onItemClick(color));
  }

  render() {
    let isColorPickerHexBG = this.state.backgroundComponentCSS === 'color-picker-hex-bg';

    return (
      <div>
        {isColorPickerHexBG ? <div className={this.state.backgroundComponentCSS}/> : null}
        
        <div className={this.state.componentCSS}>
          <Row colors={['003366', '336699', '3366CC', '003399', '000099', '0000CC', '000066']}
              selectedColor={this.state.selectedColor} onItemClick={this.onItemClick}/>
          <Row colors={['006666', '006699', '0099cc', '0066cc', '0033cc', '0000ff', '3333ff', '333399']}
              selectedColor={this.state.selectedColor} onItemClick={this.onItemClick}/>
          <Row colors={['669999','009999','33cccc','00ccff','0099ff','0066ff','3366ff','3333cc','666699']}
              selectedColor={this.state.selectedColor} onItemClick={this.onItemClick}/>
          <Row colors={['339966','00ffcc','00ffcc','00ffff','33ccff', '3399ff','6699ff','6666ff','6600ff','6600cc']}
              selectedColor={this.state.selectedColor} onItemClick={this.onItemClick}/>
          <Row colors={['339933','00cc66','00ff99','66ffcc','66ffff','66ccff','99ccff','9999ff','9966ff','9933ff','9900ff']}
              selectedColor={this.state.selectedColor} onItemClick={this.onItemClick}/>
          <Row colors={['006600','00cc00','00ff00','66ff99','99ffcc','ccffff','ccccff','cc99ff','cc66ff','cc33ff','cc00ff','9900cc']}
              selectedColor={this.state.selectedColor} onItemClick={this.onItemClick}/>
          <Row colors={['003300','009933','33cc33','66ff66','99ff99','ccffcc','ffffff','ffccff','ff99ff','ff66ff','ff00ff','cc00cc','660066']}
              selectedColor={this.state.selectedColor} onItemClick={this.onItemClick}/>
          <Row colors={['336600','009900','66ff33','99ff66','ccff99','ffffcc','ffcccc','ff99cc','ff66cc','ff33cc','cc0099','993399']}
              selectedColor={this.state.selectedColor} onItemClick={this.onItemClick}/>
          <Row colors={['333300','669900','99ff33','ccff66','ffff99','ffcc99','ff9999','ff6699','ff3399','cc3399','990099']}
              selectedColor={this.state.selectedColor} onItemClick={this.onItemClick}/>
          <Row colors={['666633','99cc00','ccff33','ffff66','ffcc66','ff9966','ff6666','ff0066','cc6699','993366']}
              selectedColor={this.state.selectedColor} onItemClick={this.onItemClick}/>
          <Row colors={['999966','cccc00','ffff00','ffcc00','ff9933','ff6600','ff5050','cc0066','660033']}
              selectedColor={this.state.selectedColor} onItemClick={this.onItemClick}/>
          <Row colors={['996633','cc9900','ff9900','cc6600','ff3300','ff0000','cc0000','990033']}
              selectedColor={this.state.selectedColor} onItemClick={this.onItemClick}/>
          <Row colors={['663300','996600','cc3300','993300','990000','800000','993333']}
              selectedColor={this.state.selectedColor} onItemClick={this.onItemClick}/>

          {isColorPickerHexBG ? null : (
            <div className={this.state.backgroundComponentCSS}>
              <span className="color-picker-bg__left"/>
              <span className="color-picker-bg__right"/>
            </div>
          )}
        </div>
      </div>
    )
  }
}

const Row = ({colors, selectedColor, onItemClick}) => {
  return (
    <ul className="color-picker-row" key={uuid.v4()}>
      {colors.map(c => '#' + c).map(c => (<Item color={c} active={c === selectedColor} onItemClick={onItemClick}
                              key={uuid.v4()}/>))}
    </ul>
  )
}

const Item = ({color, active, onItemClick}) => {
  return (
    <li className={classNames('color-picker-row__item',{'color-picker-row__item--active':active})} data-color={color}
        onClick={() => onItemClick(color)}>
      <span className="color-picker-color"/>
      {active ? <span className="color-picker-color-active"/> : null}
    </li>
  );
}
